import { forwardRef, Ref, SVGProps } from 'react'

function _IconHotelTonight(props: SVGProps<SVGSVGElement>, ref?: Ref<SVGSVGElement>) {
  return (
    <svg
      id="Layer_1"
      x="0px"
      y="0px"
      width="100%"
      viewBox="0 0 392 392"
      enableBackground="new 0 0 392 392"
      xmlSpace="preserve"
      {...props}
      ref={ref}
    >
      <path
        fill="#3B2151"
        opacity={1}
        stroke="none"
        d=" M366.000000,393.000000  C244.000015,393.000000 122.500046,393.000000 1.000049,393.000000  C1.000033,262.333374 1.000033,131.666763 1.000016,1.000102  C131.666595,1.000068 262.333191,1.000068 392.999817,1.000034  C392.999878,131.666580 392.999878,262.333160 392.999939,392.999878  C384.166656,393.000000 375.333344,393.000000 366.000000,393.000000  M86.539131,215.752518  C86.747635,215.556213 86.902618,215.324158 87.924057,214.866791  C160.911652,214.866791 233.899246,214.866791 307.216492,214.866791  C307.216492,228.712341 307.216492,241.848038 307.099030,255.509827  C307.402435,255.617935 307.705841,255.726059 308.934998,255.982010  C314.927521,255.987991 320.935577,255.733429 326.907288,256.089050  C331.078339,256.337463 331.941132,254.688370 331.907776,250.892792  C331.748291,232.749985 331.837616,214.605011 331.835693,196.460800  C331.835022,190.076828 331.831329,190.075012 325.197571,190.074982  C247.793396,190.074539 170.389221,190.076111 92.985054,190.066757  C90.992493,190.066513 88.999939,189.948318 86.803864,189.533081  C86.644356,189.307953 86.444725,189.127136 86.074867,188.062546  C86.074867,169.809174 86.074867,151.555801 86.074867,133.311127  C77.597816,133.311127 69.710419,133.311127 61.751369,133.311127  C61.751369,174.019272 61.751369,214.415680 61.751369,254.700500  C69.962784,254.700500 77.884964,254.700500 86.204964,254.700500  C86.204964,241.604935 86.204964,228.807098 86.539131,215.752518  z"
      />
      <path
        fill="#FFFFFF"
        opacity={1}
        stroke="none"
        d=" M87.007385,189.885132  C88.999939,189.948318 90.992493,190.066513 92.985054,190.066757  C170.389221,190.076111 247.793396,190.074539 325.197571,190.074982  C331.831329,190.075012 331.835022,190.076828 331.835693,196.460800  C331.837616,214.605011 331.748291,232.749985 331.907776,250.892792  C331.941132,254.688370 331.078339,256.337463 326.907288,256.089050  C320.935577,255.733429 314.927521,255.987991 308.371582,255.738312  C307.657196,255.270767 307.459961,255.100479 307.216492,254.983734  C307.216492,241.848038 307.216492,228.712341 307.216492,214.866791  C233.899246,214.866791 160.911652,214.866791 87.182938,214.936478  C86.362854,215.340530 86.283905,215.674881 86.204956,216.009247  C86.204964,228.807098 86.204964,241.604935 86.204964,254.700500  C77.884964,254.700500 69.962784,254.700500 61.751369,254.700500  C61.751369,214.415680 61.751369,174.019272 61.751369,133.311127  C69.710419,133.311127 77.597816,133.311127 86.074867,133.311127  C86.074867,151.555801 86.074867,169.809174 86.086983,188.797272  C86.401855,189.649719 86.704620,189.767426 87.007385,189.885132  z"
      />
      <path
        fill="#4F3863"
        opacity={1}
        stroke="none"
        d=" M86.905624,189.709106  C86.704620,189.767426 86.401855,189.649719 86.152031,189.261307  C86.444725,189.127136 86.644356,189.307953 86.905624,189.709106  z"
      />
      <path
        fill="#4F3863"
        opacity={1}
        stroke="none"
        d=" M86.372040,215.880890  C86.283905,215.674881 86.362854,215.340530 86.722939,215.031250  C86.902618,215.324158 86.747635,215.556213 86.372040,215.880890  z"
      />
      <path
        fill="#E6E2E8"
        opacity={1}
        stroke="none"
        d=" M307.157776,255.246780  C307.459961,255.100479 307.657196,255.270767 307.908722,255.664383  C307.705841,255.726059 307.402435,255.617935 307.157776,255.246780  z"
      />
    </svg>
  )
}

export const IconHotelTonight = forwardRef(_IconHotelTonight)
